export default __webpack_public_path__ + "static/media/erroricon.2f374065.png";